import React, { useContext } from 'react'
import { Selected } from '../../../context/context'
import MobileSlider from './MobileSlider'
import {
    Container,
    Title,
    CardsContainer,
    Card,
    CardTitle,
    Feature,
    DesktopContent,
} from './Elements'
import {
    containerMotion,
    cardMotion,
} from './Motion'

import { tecnicas } from './content'

const Tecnica = () => {

    const [selected, setSelected] = useContext(Selected)

    const handleClick = (tecnica) => {
        setSelected({...selected, tecnica: tecnica})
    }

    return(
        <>
            <DesktopContent>
                <Title>Seleccioná el tipo de personalizado</Title>
                <CardsContainer
                variants={containerMotion}
                initial='initial'
                animate='animate'
                exit='exit'
                >
                    {
                        tecnicas.length > 0 &&
                        tecnicas.map(item => {
                            return(
                                <Card
                                    variants={cardMotion}
                                    key={item.title}
                                    onClick={() => handleClick(item.tech)}
                                    to='/producto'
                                    background={item.img}
                                >
                                    <CardTitle>
                                        {item.title}
                                    </CardTitle>
                                    {
                                        item.properties.map(item => {
                                            return <Feature>{item}</Feature>
                                        })
                                    }
                                </Card>
                            )
                        })
                    }
                </CardsContainer>
            </DesktopContent>
            <MobileSlider />
        </>
    )
}

export default Tecnica